/*
 * Created Date: Thursday, November 14th 2024, 4:27:16 pm
 * Author: masoncai
 *
 * Copyright (c) 2024 Your Company
 */
import { extractMethodName } from './request';

/**
 * 调用 relay 的 rule API, 可以按需处理 response.body
 * 支持 Server-Sent Events
 * @param {String} schema 被调模块，如 e2e，可以在七彩石配置中查看
 * @param {Object} postData 请求体
 * @returns Response https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
 */
async function ruleAPI(schema, postData) {
  const response = await fetch(`/relay/rapi/${schema}?method=${extractMethodName(postData)}`, {
    method: 'POST',
    body: JSON.stringify(postData),
    headers:{
        userid: sessionStorage.getItem('userid'),
        authToken: sessionStorage.getItem('AuthToken'),

    }
  });
  if (!response.ok) {
    throw new Error(`请求后端RuleAPI出错: ${response.status}`);
  }

  return response;
}

export { ruleAPI };
